import { render, staticRenderFns } from "./BreederShedDetail.vue?vue&type=template&id=12d18b1f&"
import script from "./BreederShedDetail.vue?vue&type=script&lang=js&"
export * from "./BreederShedDetail.vue?vue&type=script&lang=js&"
import style0 from "./BreederShedDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports